import { apiUrls } from "../../src/assets/config";
import { colorDistance, getCurrentCanvas, setLoader } from "../helpers/helper";
import {fabric} from "fabric";

// Function to replace color in selected image
export function replaceColorCanvasApi(replaceForColor, replaceWithColor, currentObj? : any) {
  // Get the selected object (assuming it's an image)
  let selectedObject = currentObj ?? getCurrentCanvas().getActiveObject();
  const targetColor = replaceForColor;
  const replacementColor = replaceWithColor;

  // Define the maximum color difference threshold
  const maxColorDifference = currentObj ? 50 : 80; // Adjust as needed

  // Get scaled width and height of the selected object
  const scaledWidth = selectedObject.width;
  const scaledHeight = selectedObject.height;

  // Convert the Fabric.js image object to a canvas element
  const tempCanvas2 = document.createElement("canvas");
  const tempCtx2 = tempCanvas2.getContext("2d");
  tempCanvas2.width = scaledWidth;
  tempCanvas2.height = scaledHeight;
  tempCtx2.drawImage(selectedObject._element, 0, 0, scaledWidth, scaledHeight);

  // Get the image data from the temporary canvas
  const imageData = tempCtx2.getImageData(
    0,
    0,
    tempCanvas2.width,
    tempCanvas2.height
  );
  const data = imageData.data;

  // Loop through each pixel
  for (let i = 0; i < data.length; i += 4) {
    // Get the color of the pixel
    let pixelColor = [data[i], data[i + 1], data[i + 2]];

    // Check if the color is close to the target color
    if (colorDistance(pixelColor, targetColor) <= maxColorDifference) {
      // Replace the pixel's color with the replacement color
      data[i] = replacementColor[0];
      data[i + 1] = replacementColor[1];
      data[i + 2] = replacementColor[2];
      // Note: data[i + 3] is the alpha channel (transparency), leave it unchanged
    }
  }

  // Put the modified image data back onto the temporary canvas
  tempCtx2.putImageData(imageData, 0, 0);
  return tempCanvas2.toDataURL();
}

export const getSingleColorLogo = async (url, logoColors, replaceWithColor) => {
  let currentUrl = url;
  let isUrlUpdate = false; 

  const getNewImageObj = async (currentUrl) => {
    const imgURL = isUrlUpdate ? currentUrl : apiUrls.convertedImage.concat(currentUrl);
    const tempCanvasForColorChange = new fabric.Canvas(`tempCanvasForColorChange`, {
      selection: false,
      controlsAboveOverlay: true,
       // @ts-ignore
      uniScaleKey: false,
    });

    return new Promise((resolve, reject) => {
      fabric.Image.fromURL(
        imgURL,
        (img) => {
          if (tempCanvasForColorChange) {
            const image = img.set({
              objectCaching: false,
            });

            tempCanvasForColorChange.add(image);
            setLoader(false);
            tempCanvasForColorChange.setActiveObject(image);
            tempCanvasForColorChange.renderAll();
            resolve(image);
          } else {
            reject(new Error('Canvas initialization failed'));
          }
        },
        { crossOrigin: 'Anonymous' }
      );
    });
  };

  for (const replaceForColor of logoColors) {
    const activeObj = await getNewImageObj(currentUrl);
    currentUrl = replaceColorCanvasApi(replaceForColor, replaceWithColor, activeObj);
    isUrlUpdate = true;
  }

  return currentUrl;
};

